import styled from 'styled-components';
import { media } from 'designsystem/index';

const Icon = styled.img`
    width: 80%;
    margin:0 auto;
    max-width:350px;
    ${media.desktop`
        width: 100%;
    `};
`;

export default Icon;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CardSlider/FeatureCard/Icon.jsx